import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { askDataKeyValue } from "../../../utils/actions/firebase/firebaseActions";

export default function ViewPresentations() {
	let { id } = useParams();
	const [source, setSource] = useState("");
	const [type, setType] = useState("");
	const company = localStorage.getItem("usuariosEmpresa");

	useEffect(() => {
		const askDocuments = async () => {
			const nameCollection = "coursesMaterial-" + company;
			const key = "id";
			const value = id;
			const response = await askDataKeyValue(nameCollection, key, value);

			if (response?.data?.length > 0) {
				const url = response.data[0].presentationsResource;
				setSource(url);
				detectType(url);
			}
		};

		askDocuments();
	}, [id, company]);

	const isAndroid = /Android/i.test(navigator.userAgent);
	const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

	const detectType = (url) => {
		const clean = url.split("?")[0].toLowerCase();
		if (clean.endsWith(".pdf")) return setType("pdf");
		if (clean.match(/\.(jpg|jpeg|png|gif|webp)$/)) return setType("image");
		if (clean.match(/\.(mp4|webm|ogg)$/)) return setType("video");
		setType("unknown");
	};

	const renderContent = () => {
		// ----- PDF -----
		if (type === "pdf") {
			// ✅ iOS: abrir directamente (única forma correcta)
			if (isIOS) {
				return (
					<div style={{ textAlign: "center", padding: "2rem" }}>
						<p>iOS no permite mostrar PDFs multipágina dentro de apps.</p>
						<a
							href={source}
							target="_blank"
							rel="noopener noreferrer"
							className="btnViewDocuments"
						>
							Abrir documento completo
						</a>
					</div>
				);
			}

			// ✅ Android: Google Viewer
			if (isAndroid) {
				const viewer = `https://docs.google.com/gview?url=${encodeURIComponent(
					source
				)}&embedded=true`;
				return (
					<iframe
						src={viewer}
						title="PDF Android"
						frameBorder="0"
						style={{ width: "100%", height: "100vh" }}
					/>
				);
			}

			// ✅ Web y Desktop
			return (
				<iframe
					src={source}
					title="PDF Web"
					frameBorder="0"
					style={{ width: "100%", height: "100vh" }}
				/>
			);
		}

		// ----- IMAGE -----
		if (type === "image") {
			return (
				<img
					src={source}
					alt="Documento"
					style={{ width: "100%", height: "100%", objectFit: "contain" }}
				/>
			);
		}

		// ----- VIDEO -----
		if (type === "video") {
			return (
				<video
					src={source}
					controls
					style={{ width: "100%", height: "100%" }}
				/>
			);
		}

		// ----- UNKNOWN -----
		return (
			<div style={{ padding: "2rem", textAlign: "center" }}>
				<p>No se puede previsualizar el archivo.</p>
				<a href={source} target="_blank" rel="noopener noreferrer">
					Abrir archivo
				</a>
			</div>
		);
	};

	return (
		<div style={{ width: "100%", height: "100vh", background: "#fff" }}>
			{source ? renderContent() : <p>Cargando material…</p>}
		</div>
	);
}

// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router";
// import { askDataKeyValue } from "../../../utils/actions/firebase/firebaseActions";

// export default function ViewPresentations(props) {
// 	let { id } = useParams();
// 	const [source, setSource] = useState("");
// 	const company = localStorage.getItem("usuariosEmpresa");

// 	const askDocuments = async () => {
// 		const nameCollection = "coursesMaterial-" + company;
// 		const key = "id";
// 		const value = id;
// 		const response = await askDataKeyValue(nameCollection, key, value);
// 		console.log("response:", response.data[0].resurce);
// 		setSource(response.data[0].presentationsResource);
// 	};

// 	useEffect(() => {
// 		askDocuments();
// 	}, []);

// 	return (
// 		<div>
// 			{console.log("en el componente, source: ", source)}
// 			{source && (
// 				<div className="view-documents-container">
// 					{/* <iframe src={source} frameborder="0" className="view-documents" /> */}
// 					<object data={source} frameborder="0" className="view-documents" />
// 					{/* <iframe src=`http://docs.google.com/gview?url=${source}&embedded=true`  frameborder="0" /> */}
// 				</div>
// 			)}
// 		</div>
// 	);
// }
